import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteRestaurants = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteRestaurant`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheRestaurant = async (page) => {
    return await axios.get(`${BASE_URL}/api/societe/afficheRestaurant/${page}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const ModifierRestaurant = async (idRestaurant, data) => {
    return await axios.put(`${BASE_URL}/api/societe/modifierRestaurant/${idRestaurant}`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerRestaurant = async (idRestaurant) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteRestaurant/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const EnvoyeEmail = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/envoyeEmailResto`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const AuthRestaurantRequest = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/authRestaurantSociete`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

export { AjouteRestaurants, AfficheRestaurant, ModifierRestaurant, SuprimerRestaurant, EnvoyeEmail, AuthRestaurantRequest }